import { render, staticRenderFns } from "./SendEmailWrap.vue?vue&type=template&id=77474a1d&"
import script from "./SendEmailWrap.vue?vue&type=script&lang=js&"
export * from "./SendEmailWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports